<template>
  <!-- 停車場容留狀況 -->
  <div>
    <div class="d-flex justify-content-end">
      <button  class="btn btn-dia "  @click="showModal()" style="" v-if="!isShortView">
        <i class="fas fa-search-plus"></i>
      </button>
    </div>
    <div id="chart">
      <apexchart
        v-if="chartSeries"
        type="bar"
        :options="chartOptions"
        :series="chartSeries"
      >
    </apexchart>
      <div class="text-center d-flex justify-content-center flex-column flex-sm-row mx-auto mb-2 mx-sm-3">
         <div class=" me-sm-3  green-item p-1 text-white rounded fw-bolder text-parking mb-1 w-50  mx-auto mx-sm-0">80% 以下</div>
         <div class=" me-sm-3 yellow-item p-1 text-white rounded fw-bolder text-parking mb-1 w-50  mx-auto mx-sm-0">80% ~ 90%</div>
         <div class=" me-sm-3 red-item p-1 text-white rounded fw-bolder text-parking mb-1 w-50   mx-auto mx-sm-0">90% 以上</div>
      </div>
    </div>
    
    <dialog-modal  id="parkingAreaStatusPop" ref="objectDetectionDetail" :showUpdateButton="false" :customUpdateButton="false" :modalSize="'xl'"
      :isImage="false" :isMarginAuto="false" :modalTitle="'停車場容留狀況'" :closeButton="false" >
      <div class="object-detection-detail w-75 m-auto" >
            <apexchart
            id="chartPop"
            v-if="chartSeries"
            type="bar"
            :options="chartOptions"
            :series="chartSeries"
          >
          </apexchart>
          <div class="text-center">
         <p class="d-inline me-3 green-item p-1 text-white rounded fw-bolder text-parking">80% 以下</p>
         <p class="d-inline me-3 yellow-item p-1 text-white rounded fw-bolder text-parking">80% ~ 90%</p>
         <p class="d-inline me-3 red-item p-1 text-white rounded fw-bolder text-parking">90% 以上</p>
      </div>
      </div>
    </dialog-modal>
  </div>
</template>

<script>
import moment from "moment";
import VueApexCharts from "vue-apexcharts";
import DialogModal from "./DialogModal.vue";

import CONST from "../utils/const";
import Utils from "../utils/utils";
import { mapState, mapGetters } from "vuex";
const zh_tw = require("../utils/apexchartObject/apexLocales/zh-tw.json");
export default {
  data() {
    return {
      dataInterval: null,
      chartData: [],
      busData: null,
      carData: null,
      chart: null,
      viewPort: window.innerWidth,
      isShortView:false,
      chartSeries: [
        {
          name: "車位使用率",
          data: [], // 各停車場的車位使用率 
        },
      ],
      chartOptions: {
        colors: ["#5db2fa","#92cc77"],
        chart: {
          type: 'bar',
          // stacked: true,
          // height: "250",

          defaultLocale: "zh-tw",
          locales: [zh_tw],
          toolbar: {
            show: true,
            tools: {
              download: true,
              selection: false,
              zoom: false,
              zoomin: false,
              zoomout: false,
              pan: false,
              reset: false,
            },
            export: {
              csv: {
                filename: "custom_csv",
              },
              svg: {
                filename: "custom_svg",
              },
              png: {
                filename: "custom_png",
              },
            },
          },
        },
        plotOptions: {
          bar: {
            dataLabels:{
              enabled: true,
              position: 'center',
              total:{
                enabled: true,
              },
            },
         
            horizontal: true, // 使其成為橫向長條圖
            colors: {
              // backgroundBarColors: ["#8baded"], // 使用淺藍色為背景色
              backgroundBarOpacity: 1, // 設定背景顏色的透明度
              // ranges: [
              //   // { from: 0, to: 0.8, color: "#92cc77" }, // 80%以下為綠色
              //   { from: 0.8, to: 0.9, color: "#ffa94e" }, // 80~90%為橘色
              //   { from: 0.9, to: 10000, color: "#ff7676" }, // 90%以上為紅色
              // ],
            },
          },
        },
        stroke: {
          width: 0,
        },
        legend: {
          show: false,

        },
        fill:{
          colors: [function({ seriesIndex, dataPointIndex, w }) {
          const total = w.config.series.reduce((a, b) => {
          return a + (b.data[dataPointIndex] ? b.data[dataPointIndex] : 0);
        }, 0);

        if(total <0.8){
          return '#92cc77'; // 綠色
        }else if(total  <0.9){
          return '#ffa94e'; // 橘色
        }else{
          return '#ff7676'; // 红色

        }
  
    
         },]
        },
        // colors: [function({ value, seriesIndex, w }) {
        //     if (value < 0.8) {
        //       return '#00E396'; // 綠色
        //     } else if (value < 0.9) {
        //       return '#FEB019'; // 橘色
        //     } else {
        //       return '#FF4560'; // 紅色
        //     }
        //   }],
        states:{
          hover:{
            filter:{
              type: 'none',
            }
          }
        },
        xaxis: {
          // categories: [], // 停車場名稱 測試資料
          labels: {
            formatter: function (value) {
              return Math.round(value * 100) + "%"; // 將x軸的小數值轉換為百分比
            },
          },
          min: 0,
          max: 1,
          tickAmount: 5,
        },
        dataLabels: {
          enabled: true,
          
          // textAnchor: "start",
          style: {
            colors: ["#333"], // 設置數據標籤的顏色，根據需要進行調整
            fontSize: "12px",
          },
          formatter:
            function (val, opts) {
              // return val * 100 + "%";
              return Math.round(val*100) + "%";
            },
          // offsetX:0
        },
        tooltip: {
          enabled:false,
          y: {
            // formatter: function (val) {
            //   return Math.round(val * 100) + "%"; // 轉換為百分比格式，並四捨五入到小數點後一位
            // },
            formatter:undefined,
            title: {
              formatter: function (val) {
                return "";
              },
            },
          },
        },
      },
    };
  },
  components: {
    apexchart: VueApexCharts,DialogModal
  },
  computed: {
    // vehicleAndPeople() {
    //   return this.$store.getters["elasticMonitor/getVehicleAndPeople"];
    // },
    ...mapGetters("elasticMonitor", {
      vehicleAndPeople: "getVehicleAndPeople",
    }),
    ...mapGetters("scenicArea", { myScenicAreaList: "getMyScenicArea" }),
  },
  watch: {
    vehicleAndPeople: {
      async handler(newVal) {
        // console.log("watch",newVal);
        this.setChartDataAndDraw();
      },
      // immediate:true,
    },
    myScenicAreaList() {
      this.setChartDataAndDraw();
    },

    viewPort:{
      handler(newVal){
        if(newVal < 600){
        this.isShortView = true;
      }else{
        this.isShortView = false;
      }},
      immediate: true
    },
  },
  methods: {

    showModal(){
      this.$refs.objectDetectionDetail.openModal();
    },
    async setChartDataAndDraw() {
      if (
        !this.myScenicAreaList ||
        this.myScenicAreaList.length == 0 ||
        !this.vehicleAndPeople ||
        this.vehicleAndPeople.length == 0
      )
        return;
      this.chartData = await this.vehicleAndPeople.filter((v) =>
        this.myScenicAreaList.find((s) => s.id == v.scenicAreaId)
      );
      this.drawChart();
    },
    drawChart() {
      let categories = this.chartData.map((current) => {
        let area = this.myScenicAreaList.find(
          (item) => item.id == current.scenicAreaId
        );
        return area.name;
      });

      let vm = this.chartData;
      // console.log("vm", vm);
      vm.carData = {
        name: "小客車",
        data: vm.map((item) => {
          if (item.vehicleFlowData.carInSiteFlow < 0) {
            //carInSiteFlow 可能會有負值的情況
            item.vehicleFlowData.carInSiteFlow = 0;
          }
          if (
            //判斷若carInSiteFlow大於carParkingSpace ，則固定為一樣數量
            item.vehicleFlowData.carInSiteFlow >
            item.vehicleFlowData.carParkingSpace
          ) {
            item.vehicleFlowData.carInSiteFlow =
              item.vehicleFlowData.carParkingSpace;
          }
          let a =
            item.vehicleFlowData.carInSiteFlow /
          
            (item.vehicleFlowData.carParkingSpace +
              item.vehicleFlowData.busParkingSpace);

          if (a > 1) {
            //判斷若a 換算後大於1 (為 > 100 %) ，則固定為 1
            a = 1;
          }
          return Math.round(a * 100) / 100;
   
        }),
      };
      // console.log("this.",vm.carData)

      vm.busData = {
        name: "大客車", // busInSiteFlow 已含 busInSiteFlow & smallBusInSiteFlow 資料
        data: vm.map((item) => {
    
          if (item.vehicleFlowData.busInSiteFlow < 0) {
            item.vehicleFlowData.busInSiteFlow = 0;
          }


          if ( item.vehicleFlowData.busInSiteFlow > item.vehicleFlowData.busParkingSpace) {
            item.vehicleFlowData.busInSiteFlow = item.vehicleFlowData.busParkingSpace;
          }
          let b =
          item.vehicleFlowData.busInSiteFlow /
            (item.vehicleFlowData.carParkingSpace +
              item.vehicleFlowData.busParkingSpace );
          // console.log("a", Math.round(a * 10) / 10);
          if (b > 1) {
            //判斷若a 換算後大於1 (為 > 100 %) ，則固定為 1
            b = 1;
          }
          return Math.round(b * 100) / 100;
          // return 0.5
        }),
      };
      // console.log("thisA",this.busData)
        let combinedData = vm.busData.data.map((value, index) => {
          return value + (vm.carData.data[index] || 0);
        });


      let TotalData = {
        name: "總容留率",
        data:vm.map((item) => {
          // return  Math.floor(a *100)/100;// 無條件捨去換算後小數點位
          const ratio = item.vehicleFlowData.fourWheelParkingUsageRatio 
          const value = ratio > 1 ? 1 : ratio < 0 ? 0 : ratio;
          return (Math.floor(value * 100) / 100 );// 無條件捨去換算後小數點位
        }),
      }



      this.chartSeries = [TotalData];
      // this.chartSeries = [carData, busData, mortorData];

      // console.log("this.chartSeries", this.chartSeries);
      let newOptions = { ...this.chartOptions };
      newOptions.tooltip.y.formatter = function (val,{ series, seriesIndex, dataPointIndex,w }) {
        let carData = vm.carData;
        let busData = vm.busData;
        // console.log("vale",index);
        // console.log("大",busData);
        // console.log("小",carData);

        return `大型車  ${((busData.data[dataPointIndex])*100).toFixed(0)} %  <br> 小型車  ${(carData.data[dataPointIndex]*100).toFixed(0)} %`
  
        // return Math.round(value * 100) + "%";
      };

      newOptions.xaxis.categories = categories;

      newOptions.chart.toolbar.export = {
        csv: {
          filename: `停車場容留狀況_${moment().format(
            "YYYY年MM月DD日_HH時mm分"
          )}`,
        },
        svg: {
          filename: `停車場容留狀況_${moment().format(
            "YYYY年MM月DD日_HH時mm分"
          )}`,
        },
        png: {
          filename: `停車場容留狀況_${moment().format(
            "YYYY年MM月DD日_HH時mm分"
          )}`,
        },
      };
      this.chartOptions = newOptions;

    },
    chartDataLabelFormat(val, index) {
      // console.log("index", index);

      let parkingTotalSpace = ""; //停車位總數
      let parkingUseSpace = ""; // 停車位已停數
      let parkingRemainSpace = ""; //停車位剩餘數

      if (parkingUseSpace < 0) parkingUseSpace = 0;

      if (parkingUseSpace > parkingTotalSpace) {
        parkingUseSpace = parkingTotalSpace;
      }
      // parkingRemainSpace =
      //   parkingTotalSpace - parkingUseSpace >= 0
      //     ? parkingTotalSpace - parkingUseSpace
      //     : 0;
      // return `${parkingUseSpace} / ${parkingRemainSpace}`; //已停:剩餘
    },
  },
  async mounted() {
    await this.setChartDataAndDraw();
    this.$_resizeEventHandler = () => {
      this.viewPort = window.innerWidth;
    };
    window.addEventListener('resize', this.$_resizeEventHandler);
    // this.chartOptions.dataLabels.formatter = this.chartDataLabelFormat;
    if (this.vehicleAndPeople?.length == 0) {
    } else {
      this.setChartDataAndDraw();
    }
  },
};
</script>

<style lang="scss" scoped>
#chart {
  max-width: 450px;
  margin: 0 auto;
}

.green-item{
  background-color:#92CC77;

}

.yellow-item{
  background-color:#FFA94E;
}

.red-item{
  background-color:#FF7676;
}

.text-parking{
  font-size: 12px;
}


</style>
